var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 0.833292H18.4999L14.8333 8.16663L14.8333 19.1666H25.8333V8.16663H20.3333L23.9999 0.833292ZM9.33325 0.833292L3.83325 0.833292L0.166584 8.16663V19.1666L11.1666 19.1666L11.1666 8.16663H5.66658L9.33325 0.833292Z",
    fill: "#1A5298"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDouble);
export default __webpack_public_path__ + "static/media/double.410bf870bd835af079d0d347b77b53fb.svg";
export { ForwardRef as ReactComponent };